<mat-tab-group>
  <mat-tab label="Global" *ngIf="permissions.includes('global_config')">
    <div style="padding: 20px;">
      <h3>Mise à jour token ARL</h3>
      <form class="arl-form">
        <mat-form-field class="arl-full-width">
          <mat-label>ARL</mat-label>
          <input #arlInput [disabled]="arlError" matInput placeholder="ARL" value="">
        </mat-form-field>
      </form>
      <button color="primary" class="search-full-width-button" [disabled]="arlError" mat-flat-button (click)="updateARL(arlInput)">Enregistrer</button>

      <mat-accordion style="clear: both; display: block;">
        <mat-expansion-panel>
          <mat-expansion-panel-header>
            <mat-panel-title>
              Aide récupération ARL
            </mat-panel-title>
            <mat-panel-description>
              Informations supplémentaires pour récupération clé ARL
            </mat-panel-description>
          </mat-expansion-panel-header>
          <p>
            <strong>Chrome</strong><br><br>

            -> Open Chrome<br>
            -> Go to www.deezer.com and log into your account<br>
            -> After logging in press F12 to open up Developer Tools<br>
            -> Go under the Application tab (if you don't see it click the double arrow)<br>
            -> Open the cookie dropdown<br>
            -> Select www.deezer.com<br>
            -> Find the arl cookie (It should be 192 chars long)<br>
            -> CopyPaste the value it into the login form<br><br><br>


            <strong>Firefox</strong><br><br>

            -> Open Firefox<br>
            -> Go to www.deezer.com and log into your account<br>
            -> After logging in press F12 to open up Developer Tools<br>
            -> Go under the Storage tab (if you don't see it click the double arrow)<br>
            -> Open the cookie dropdown<br>
            -> Select www.deezer.com<br>
            -> Find the arl cookie (It should be 192 chars long)<br>
            -> CopyPaste the value it into the login form
          </p>
        </mat-expansion-panel>
      </mat-accordion>

    </div>
  </mat-tab>
  <mat-tab label="Utilisateurs" *ngIf="permissions.includes('user_config')">
    <div fxLayout fxLayoutAlign="center center">
      <mat-form-field fxFlex="40%" style="width: 100%; margin-top: 20px;">
        <input matInput type="text" (keyup)="doFilter($event.target.value)" placeholder="Filtre">
      </mat-form-field>
    </div>

    <table style="width: 100%" mat-table [dataSource]="usersMatTable" matSort matSortActive="effective_role_id" matSortDirection="asc">

      <ng-container matColumnDef="uid">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> UID </th>
        <td mat-cell *matCellDef="let element"> {{ element.uid }} </td>
      </ng-container>

      <ng-container matColumnDef="name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Nom </th>
        <td mat-cell *matCellDef="let element"> {{ element.name }} </td>
      </ng-container>

      <ng-container matColumnDef="mail">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Mail </th>
        <td mat-cell *matCellDef="let element"> {{ element.mail }} </td>
      </ng-container>

      <ng-container matColumnDef="team_name">
        <th mat-header-cell *matHeaderCellDef mat-sort-header> Team </th>
        <td mat-cell *matCellDef="let element"> {{ element.team_name }} </td>
      </ng-container>

      <ng-container matColumnDef="effective_role">
        <th mat-header-cell *matHeaderCellDef> Rôle effectif </th>
        <td mat-cell *matCellDef="let element">
          <span [style.color]="element.custom_role_id ? '#27ae60' : '#95a5a6'">
            {{ element.effective_role_name }}
            <span *ngIf="element.custom_role_id" style="font-size: 0.8em;"> (personnalisé)</span>
          </span>
        </td>
      </ng-container>

      <ng-container matColumnDef="stations">
        <th mat-header-cell *matHeaderCellDef> Stations </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.stations">{{ getStationsLabels(element.stations) }}</span>
          <span *ngIf="!element.stations" style="color: #95a5a6; font-style: italic;">Réglage par défaut</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="categorie">
        <th mat-header-cell *matHeaderCellDef> Catégorie pour "Sons" </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.categorie">{{ getCategorieLabel(element.categorie) }}</span>
          <span *ngIf="!element.categorie" style="color: #95a5a6; font-style: italic;">Pas de sélection automatique</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="hiddencolumns">
        <th mat-header-cell *matHeaderCellDef> Colonnes cachées </th>
        <td mat-cell *matCellDef="let element">
          <span *ngIf="element.hiddencolumns">{{ getHiddencolumnsLabels(element.hiddencolumns) }}</span>
          <span *ngIf="!element.hiddencolumns" style="color: #95a5a6; font-style: italic;">Réglage par défaut</span>
        </td>
      </ng-container>

      <ng-container matColumnDef="edit">
        <th mat-header-cell *matHeaderCellDef> Actions </th>
        <td mat-cell *matCellDef="let element">
          <!-- Bouton vert si l'utilisateur a des réglages personnalisés -->
          <button *ngIf="element.custom_role_id || element.stations || element.categorie || element.hiddencolumns"
                  (click)="editUser(element)" color="primary"
                  style="min-width: 48px; padding: 0 8px; margin-right: 8px; background-color: rgb(39, 174, 96);"
                  mat-flat-button>
            <mat-icon svgIcon="edit" style="margin: auto;"></mat-icon>
          </button>
          <!-- Bouton bleu si l'utilisateur n'a pas de réglages personnalisés -->
          <button *ngIf="!element.custom_role_id && !element.stations && !element.categorie && !element.hiddencolumns"
                  (click)="editUser(element)" color="primary"
                  style="min-width: 48px; padding: 0 8px; margin-right: 8px;"
                  mat-flat-button>
            <mat-icon svgIcon="add" style="margin: auto;"></mat-icon>
          </button>
        </td>
      </ng-container>

      <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
      <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
    </table>
    <mat-paginator #Paginator [length]="users.length"
                   [pageSize]="100" [pageSizeOptions]="[100, 200, 500]" showFirstLastButtons></mat-paginator>
  </mat-tab>
  <mat-tab label="Catégories" *ngIf="permissions.includes('category_config')">
    <div style="padding: 20px;">
      <div style="display: flex; justify-content: space-between; align-items: center; margin-bottom: 16px;">
        <mat-form-field style="width: 40%;">
          <input matInput type="text" (keyup)="doCategoryFilter($event.target.value)" placeholder="Filtre">
        </mat-form-field>
        <button mat-flat-button color="primary" (click)="editCategory()">
          <mat-icon svgIcon="add" style="margin-right: 4px;"></mat-icon>
          Ajouter une catégorie
        </button>
      </div>

      <table style="width: 100%" mat-table [dataSource]="categoriesMatTable">

        <ng-container matColumnDef="label">
          <th mat-header-cell *matHeaderCellDef> Nom (WinMedia) </th>
          <td mat-cell *matCellDef="let cat"> {{ cat.label }} </td>
        </ng-container>

        <ng-container matColumnDef="path">
          <th mat-header-cell *matHeaderCellDef> Chemin disque M: </th>
          <td mat-cell *matCellDef="let cat">
            <span *ngIf="cat.path">{{ cat.path }}</span>
            <span *ngIf="!cat.path" style="color: #95a5a6; font-style: italic;">—</span>
          </td>
        </ng-container>

        <ng-container matColumnDef="import_sons">
          <th mat-header-cell *matHeaderCellDef> Import sons </th>
          <td mat-cell *matCellDef="let cat">
            <span [style.color]="cat.import_sons ? '#27ae60' : '#95a5a6'">
              {{ cat.import_sons ? 'Oui' : 'Non' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="preselect_playlist">
          <th mat-header-cell *matHeaderCellDef> PréSélection </th>
          <td mat-cell *matCellDef="let cat">
            <span [style.color]="cat.preselect_playlist ? '#27ae60' : '#95a5a6'">
              {{ cat.preselect_playlist ? 'Oui' : 'Non' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="edit_winmedia">
          <th mat-header-cell *matHeaderCellDef> Édit. WinMedia </th>
          <td mat-cell *matCellDef="let cat">
            <span [style.color]="cat.edit_winmedia ? '#27ae60' : '#95a5a6'">
              {{ cat.edit_winmedia ? 'Oui' : 'Non' }}
            </span>
          </td>
        </ng-container>

        <ng-container matColumnDef="edit">
          <th mat-header-cell *matHeaderCellDef> Actions </th>
          <td mat-cell *matCellDef="let cat">
            <button (click)="editCategory(cat)" color="primary"
                    style="min-width: 48px; padding: 0 8px;"
                    mat-flat-button>
              <mat-icon svgIcon="edit" style="margin: auto;"></mat-icon>
            </button>
          </td>
        </ng-container>

        <tr mat-header-row *matHeaderRowDef="catDisplayedColumns"></tr>
        <tr mat-row *matRowDef="let row; columns: catDisplayedColumns;"></tr>
      </table>
    </div>
  </mat-tab>
</mat-tab-group>
